import 'core-js/modules/es.array.concat';
import 'core-js/modules/es.array.filter';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.array.join';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.number.constructor';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.set';
import 'core-js/modules/es.string.iterator';
import 'core-js/modules/es.string.match';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import 'core-js/modules/es.string.starts-with';
import 'core-js/modules/es.string.trim';
import 'core-js/modules/web.dom-collections.for-each';
import 'core-js/modules/web.dom-collections.iterator';
import { assertType, assertRange } from 'yaassertion';
import { isWorldReadyInstance } from '@paypalcorp/worldready-core';
import { createPhoneHandler } from 'fullstack-phone/client';
import Cldr from 'cldrjs/dist/cldr';

var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function globalizeToWorldReadyError(error) {
  if (error.code === "E_MISSING_CLDR") {
    return getMissingMetadataError(error.stack);
  }
  return new Error(["Oops, internal error", error.message, error.stack].join("\n"));
}
function validateCldr(path, value, options) {
  if (options === void 0) {
    options = {
      skip: []
    };
  }
  var skipBoolean = options.skip.some(function (regex) {
    return regex.test(path);
  });
  if (skipBoolean) {
    return;
  }
  if (value === undefined) {
    throw getMissingMetadataError(path);
  }
}

/**
 * This list is not comprehensive list of errors that worldready sdk throws
 * for PhoneNumberFormat.parse API. Most of the errors come from fullstack-phone
 * library that worldready sdk directly forwards to client applications.
 * The errors defined here are for the checks that worldready-sdk does on top
 * of the validations performed by fullstack phone.
 */
var PHONE_ERRORS = {
  ALPHA_CHARACTERS: "PHONE_ALPHA_CHARACTERS"
};
var OBSCURE_VISIBLE_DIGITS_LENGTH = 3;
function adjustPhoneNumberITU(phone, regionCode) {
  if (phone === undefined || phone === null || regionCode !== "DE") {
    return phone;
  }
  var trimmedPhone = phone.trim();
  if (trimmedPhone && trimmedPhone.length > 11 && trimmedPhone.substring(0, 2) === "49") {
    phone = trimmedPhone.substring(2);
  }
  return phone;
}
function hasAlphaCharacters(phoneString) {
  var phoneStringWithoutInitialTEL = phoneString.replace(/^\s*tel:/i, ""); // strip off initial "tel:" (if it exists)
  var parsedPhoneString = phoneStringWithoutInitialTEL.replace(/\s*ext[.=]?/i, ""); // strip off "ext." or "ext=" (if it exists)
  return Boolean(parsedPhoneString.match(/[a-zA-Z]/)); // return true if remaining string has alpha characters
}
function parseAndValidate(handler, phoneNumberToParse, regionCode) {
  // check for alpha characters other than initial "tel:" and return error if found
  // cf. https://github.paypal.com/Globalization-R/WorldReady-Design/wiki/normalizePhoneNumber-leniency-issue
  if (hasAlphaCharacters(phoneNumberToParse)) {
    var errors = [{
      code: PHONE_ERRORS.ALPHA_CHARACTERS
    }];
    return {
      errors: errors
    };
  }
  // > phoneObj or Error
  var parseResult = handler.parsePhoneNumber(phoneNumberToParse, regionCode);
  if (parseResult instanceof Error) {
    var _errors = [{
      code: parseResult.message
    }];
    return {
      errors: _errors
    };
  }
  var validationResult = handler.validatePhoneNumber(parseResult, regionCode);
  if (validationResult instanceof Error) {
    var _errors2 = [{
      code: validationResult.message
    }];
    return {
      errors: _errors2
    };
  }
  return parseResult;
}
function parsePhone(phoneNumber, phoneRegion, handler, regionGroups) {
  var phone = adjustPhoneNumberITU(phoneNumber, phoneRegion);
  var parseValidateResult = parseAndValidate(handler, phone, phoneRegion);
  if (!parseValidateResult.errors) {
    return parseValidateResult;
  }
  if (regionGroups) {
    for (var i = 0; i < regionGroups.length; i++) {
      var subRegionResult = parseAndValidate(handler, phone, regionGroups[i]);
      if (!subRegionResult.errors) {
        return subRegionResult;
      }
    }
  }
  return parseValidateResult;
}
function formatPhone(phoneObj, handler, style, obscure) {
  if (obscure === true && ["national", "international"].includes(style)) {
    var regex = /\d/g;
    var formattedPhoneNumber = handler.formatPhoneNumber(phoneObj, {
      style: style
    });
    var digits = formattedPhoneNumber.match(regex);
    var maskedDigitsLength, firstVisibleDigitsLength;

    // international style always starts with "+"
    var isInternationalStyle = formattedPhoneNumber.startsWith("+");
    // If national number is less than or equal to 3 digits,
    // then we should completely obscure the national number
    // and show the country code
    if (phoneObj != null && phoneObj.nationalNumber && phoneObj.nationalNumber.length <= OBSCURE_VISIBLE_DIGITS_LENGTH) {
      maskedDigitsLength = isInternationalStyle ? digits.length - phoneObj.countryCode.length : digits.length;
      firstVisibleDigitsLength = isInternationalStyle ? phoneObj.countryCode.length : digits.length;
    } else {
      maskedDigitsLength = isInternationalStyle ? digits.length - phoneObj.countryCode.length - OBSCURE_VISIBLE_DIGITS_LENGTH : digits.length - OBSCURE_VISIBLE_DIGITS_LENGTH;
      firstVisibleDigitsLength = isInternationalStyle ? phoneObj.countryCode.length + 1 : 1;
    }
    return formatObscured(maskedDigitsLength, firstVisibleDigitsLength, formattedPhoneNumber);
  }
  return handler.formatPhoneNumber(phoneObj, {
    style: style
  });
}
function formatObscured(maskedDigitsLength, firstVisibleDigitsLength, formattedPhoneNumber) {
  var regex = /\d/g;
  var digitsCount = 0;
  var start = 0,
    end = formattedPhoneNumber.length,
    result;
  while (result = regex.exec(formattedPhoneNumber)) {
    digitsCount++;
    if (digitsCount === firstVisibleDigitsLength + 1) {
      start = result["index"];
    }
    if (digitsCount === firstVisibleDigitsLength + maskedDigitsLength + 1) {
      end = result["index"];
    }
  }
  formattedPhoneNumber = formattedPhoneNumber.substring(0, start) + formattedPhoneNumber.replace(regex, "*").substring(start, end) + formattedPhoneNumber.substring(end);
  return "\u202A" + formattedPhoneNumber + "\u202C";
}

/**
 *
 * @param {Array} phoneRegions
 * @returns {Object} an object contains calling code and relevant phone regions
 * // For an input ['GP', 'RE', 'FR', 'GF', 'MQ', 'YT', 'BL', 'MF'], output object will be
 * {
 *   '33': [ 'FR' ],
 *   '262': [ 'RE', 'YT' ],
 *   '590': [ 'GP', 'BL', 'MF' ],
 *   '594': [ 'GF' ],
 *   '596': [ 'MQ' ]
 * }
 */
function getCallingCodeToPhoneRegionsMapping(phoneRegions) {
  var cldr = new Cldr("und");
  return phoneRegions.reduce(function (callingCodeToCountryCodeMapping, phoneRegion) {
    var callingCode = cldr.get(["supplemental/phoneData/callingCode", phoneRegion]);
    if (!callingCodeToCountryCodeMapping[callingCode]) {
      callingCodeToCountryCodeMapping[callingCode] = [];
    }
    callingCodeToCountryCodeMapping[callingCode].push(phoneRegion);
    return callingCodeToCountryCodeMapping;
  }, {});
}

/**
 *
 * @param {Array} phoneRegionGroup
 * @returns {Array}
 * // For an input ['a', 'a', 'b', 'b', 'b', 'c'], the output will be
 * // ['a', 'b', 'c']
 */
// remove duplicate calling code in case parentRegion exist in resolution-table.json
function removeDuplicateCallingCode(phoneRegionGroup) {
  return phoneRegionGroup.filter(function (phoneRegion, index) {
    return phoneRegionGroup.indexOf(phoneRegion) === index;
  });
}
function getMetadata(phoneRegion) {
  var cldr = new Cldr("und");
  var regionGroups = cldr.get(["supplemental/phoneData/regionGroups", phoneRegion]);
  var callingCode = cldr.get(["supplemental/phoneData/callingCode", phoneRegion]);
  var parentRegion = cldr.get(["supplemental/phoneData/parentRegion", callingCode]);
  var phoneRegions, callingCodePhoneRegionMapping;
  if (regionGroups) {
    phoneRegions = [phoneRegion].concat(regionGroups);
    // for every phoneRegion, add parentRegion if has;
    phoneRegions.forEach(function (phoneRegion) {
      var _callingCode = cldr.get(["supplemental/phoneData/callingCode", phoneRegion]);
      var _parentRegion = cldr.get(["supplemental/phoneData/parentRegion", _callingCode]);
      phoneRegions = _parentRegion ? [_parentRegion].concat(phoneRegions) : phoneRegions;
      phoneRegions = removeDuplicateCallingCode(phoneRegions);
      callingCodePhoneRegionMapping = getCallingCodeToPhoneRegionsMapping(phoneRegions);
    });
  } else {
    phoneRegions = parentRegion ? [parentRegion, phoneRegion] : [phoneRegion];
    callingCodePhoneRegionMapping = getCallingCodeToPhoneRegionsMapping(phoneRegions);
  }
  var countryToMetadata;
  cldr.on("get", validateCldr);
  try {
    countryToMetadata = Object.assign.apply(Object, [{}].concat(phoneRegions.map(function (phoneRegion) {
      var _ref;
      return _ref = {}, _ref[phoneRegion] = cldr.get(["supplemental/phoneData/libphonenumber", phoneRegion]), _ref;
    })));
  } finally {
    cldr.off("get", validateCldr);
  }
  var metadata = {
    regionCodes: phoneRegions,
    countryCodeToRegionCodeMap: callingCodePhoneRegionMapping,
    countryToMetadata: countryToMetadata
  };
  return {
    metadata: metadata,
    regionGroups: regionGroups,
    regionCallingCode: callingCode
  };
}
function getAllMetadata() {
  var cldr = new Cldr("und");
  var countryCodeToRegionCodeMap = cldr.get(["supplemental/phoneData/countryCodeToRegionCodeMapping"]);
  var countryToMetadata = cldr.get(["supplemental/phoneData/libphonenumber"]);
  var metadata = {
    regionCodes: Object.keys(countryToMetadata),
    countryCodeToRegionCodeMap: countryCodeToRegionCodeMap,
    countryToMetadata: countryToMetadata
  };
  return metadata;
}
function checkPhoneRegionError(phoneRegion) {
  if (!phoneRegion) {
    throw new Error("`phoneRegion` is missing in `new PhoneNumberFormat()` constructor");
  }
}

/**
 *
 * @param {String} phoneNumber
 * @returns Boolean
 */
function isInternationalPhoneNumber(phoneNumber) {
  var trimedPhoneNumber = phoneNumber.trim();
  if (trimedPhoneNumber[0] === "+") {
    return true;
  }
  return false;
}
var countryAliasMapping = {
  C2: "CN",
  UK: "GB"
};
function getResolvedRegion(region) {
  return countryAliasMapping[region] || region;
}
var INFERRED_PHONE_REGION_OVERRIDE = {
  PHONE_REGION_001: "001"
};
var styleValues = ["national", "international", "e164", "rfc3966"];
function assertParameter(options) {
  if (process.env.NODE_ENV !== "production") {
    assertType(options, "options", ["undefined", "plain object"]);
    if (isWorldReadyInstance(options) || options.region) {
      var phoneRegion = options.region;
      delete options.region;
      throw new Error("DEPRECATED: PhoneNumberFormat API has changed for consistency with other formatters, see our updated docs for more information.\nFix your code by using:\n" + ("new PhoneNumberFormat(" + JSON.stringify(Object.assign({
        phoneRegion: phoneRegion
      }, options || {})) + ");"));
    }
    if (options.phoneRegion !== undefined) {
      assertTwoLetterString(options.phoneRegion, "options.phoneRegion");
    }
    if (options.style) {
      if (["nationalObscured", "internationalObscured"].includes(options.style)) {
        var newOptions = Object.assign({}, options, {
          style: options.style.substring(0, options.style.indexOf("Obscured"))
        });
        throw new Error("DEPRECATED: PhoneNumberFormat API has changed for consistency with other formatters, see our updated docs for more information.\nFix your code by using:\n" + ("new PhoneNumberFormat(" + JSON.stringify(Object.assign({
          obscure: true
        }, newOptions || {})) + ");"));
      }
      assertRange(options.style, styleValues, "Invalid value for options.style: {style}", {
        style: options.style
      });
    }
    if (options.obscure) {
      assertType(options.obscure, "options.obscure", ["undefined", "boolean"]);
    }
  }
}
var PhoneNumberFormat = /*#__PURE__*/function () {
  function PhoneNumberFormat(options) {
    if (options === void 0) {
      options = {};
    }
    assertParameter(options);
    var _options = options,
      _options$style = _options.style,
      style = _options$style === void 0 ? "national" : _options$style,
      _options$obscure = _options.obscure,
      obscure = _options$obscure === void 0 ? false : _options$obscure;
    var phoneRegion = getResolvedRegion(options.phoneRegion);
    var metadata, regionGroups;
    if (phoneRegion) {
      var phoneRegionMetadata = getMetadata(phoneRegion);
      metadata = phoneRegionMetadata.metadata;
      regionGroups = phoneRegionMetadata.regionGroups;
    } else {
      metadata = getAllMetadata();
    }
    var fullStackPhoneHandler = createPhoneHandler(metadata);
    this.phoneFormatter = function (phoneObj) {
      return formatPhone(phoneObj, fullStackPhoneHandler, style, obscure);
    };
    this.phoneParser = function (phoneNumber) {
      if (!isInternationalPhoneNumber(phoneNumber)) {
        checkPhoneRegionError(phoneRegion);
      }
      return parsePhone(phoneNumber, phoneRegion, fullStackPhoneHandler, regionGroups);
    };
    this.phoneFormatterAsTyped = function (phoneNumber) {
      checkPhoneRegionError(phoneRegion);
      var formatter = fullStackPhoneHandler.getAsYouTypeFormatter(phoneRegion);
      var output = "";
      phoneNumber.split("").forEach(function (char) {
        output = formatter.inputDigit(char);
      });
      return output;
    };
  }
  var _proto = PhoneNumberFormat.prototype;
  _proto.format = function format(phoneObj) {
    if (process.env.NODE_ENV !== "production") {
      assertType(phoneObj, "phoneObj", ["plain object"]);
      assertPhoneObjType(phoneObj);
    }
    return this.phoneFormatter(phoneObj);
  };
  _proto.parse = function parse(localizedPhoneString) {
    if (process.env.NODE_ENV !== "production") {
      assertType(localizedPhoneString, "localizedPhoneString", ["string"]);
    }
    localizedPhoneString = localizedPhoneString.trim();
    return this.phoneParser(localizedPhoneString);
  };
  _proto.formatAsTyped = function formatAsTyped(localizedPhoneString) {
    if (process.env.NODE_ENV !== "production") {
      assertType(localizedPhoneString, "localizedPhoneString", ["string"]);
    }
    return this.phoneFormatterAsTyped(localizedPhoneString);
  };
  PhoneNumberFormat.inferPhoneNumberRegion = function inferPhoneNumberRegion(phoneObj) {
    if (process.env.NODE_ENV !== "production") {
      assertType(phoneObj, "phoneObj", ["plain object"]);
      assertPhoneObjType(phoneObj);
    }
    var fullStackPhoneHandler = createPhoneHandler(getAllMetadata());
    try {
      var inferredRegion = fullStackPhoneHandler.inferPhoneNumberRegion(phoneObj);
      // [DTWORLDAPI-3946](https://paypal.atlassian.net/browse/DTWORLDAPI-3946)
      // If returned value from fullstack is "001", convert it to null since "001" is not a valid country code.
      if (inferredRegion === INFERRED_PHONE_REGION_OVERRIDE.PHONE_REGION_001) {
        return null;
      }
      return inferredRegion;
    } catch (error) {
      throw globalizeToWorldReadyError(error);
    }
  };
  PhoneNumberFormat.inferPhoneNumberType = function inferPhoneNumberType(phoneObj) {
    if (process.env.NODE_ENV !== "production") {
      assertType(phoneObj, "phoneObj", ["plain object"]);
      assertPhoneObjType(phoneObj);
    }
    var fullStackPhoneHandler = createPhoneHandler(getAllMetadata());
    try {
      return fullStackPhoneHandler.inferPhoneNumberType(phoneObj);
    } catch (error) {
      throw globalizeToWorldReadyError(error);
    }
  };
  PhoneNumberFormat.getCallingCodeForRegions = function getCallingCodeForRegions(regions) {
    if (regions === void 0) {
      regions = [];
    }
    if (process.env.NODE_ENV !== "production") {
      assertType(regions, "regions", ["array"]);
    }
    try {
      var regionToCallingCodesMapping = {};
      regions.forEach(function (region) {
        var _getMetadata = getMetadata(getResolvedRegion(region)),
          metadata = _getMetadata.metadata,
          regionCallingCode = _getMetadata.regionCallingCode;
        var allSupportCallingCodeForRegion = Object.keys(metadata.countryCodeToRegionCodeMap);
        // Remove duplicates by converting to Set and back to array
        regionToCallingCodesMapping[region] = [].concat(new Set([regionCallingCode].concat(allSupportCallingCodeForRegion)));
      });
      return regionToCallingCodesMapping;
    } catch (error) {
      throw globalizeToWorldReadyError(error);
    }
  };
  return PhoneNumberFormat;
}();
function assertPhoneObjType(_ref2) {
  var countryCode = _ref2.countryCode,
    nationalNumber = _ref2.nationalNumber,
    extension = _ref2.extension;
  // Check well-formedness of countryCode (should be integer or string representation thereof)
  assertCanonicalInteger(countryCode, "phoneObj.countryCode");

  // Check well-formedness of nationalNumber (should be integer or string representation thereof)
  assertCanonicalInteger(nationalNumber, "phoneObj.nationalNumber");

  // Check well-formedness of extension (if provided, should be string or number)
  if (extension !== undefined) {
    // extension is optional
    assertType(extension, "phoneObj.extension", ["string", "number"]);
  }
}
function assertCanonicalInteger(parameter, parameterName) {
  // ensure that parameter is an integer or a string representation of an integer
  // and disallow empty strings
  assertType(parameter, parameterName, [], {
    condition: parameter !== "" && (typeof parameter === "string" || typeof parameter === "number") && isInteger(Number(parameter)),
    errorMessage: 'Parameter `{parameterName}` must be an integer or a string representation of an integer (e.g, `"12345"`), not {parameterType} `{{parameterValue}}`'
  });
}
function assertTwoLetterString(parameter, parameterName) {
  assertType(parameter, parameterName, [], {
    condition: typeof parameter === "string" && parameter.length === 2,
    errorMessage: "Parameter `{parameterName}` must be a two-letter string, not {parameterType} `{{parameterValue}}`"
  });
}
function isInteger(x) {
  return Math.round(x) === x;
}

export { PhoneNumberFormat };
